import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/$')({
  component: Component,
});

function Component() {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 p-4">
      <h1 className="text-2xl font-semibold">Page Not Found</h1>
      <p className="text-muted-foreground">The site you are looking for does not exist.</p>
      <Link to="/" className="text-link underline">
        Go to homepage
      </Link>
    </div>
  );
}
